const COMBINING_MARKS = /[\u0300-\u036f]/g;

const fold = text =>
  text.normalize('NFD').replace(COMBINING_MARKS, '').toLowerCase();

const normalizeQuery = query => fold((query || '').trim());

const contains = (text, needle) =>
  typeof text === 'string' && fold(text).includes(needle);

const scopeOf = bands => {
  if (bands.size === 0) return 'none';
  if (bands.size === 2) return 'both';
  return bands.has('team') ? 'allTeam' : 'allCustomer';
};

export const computeSearch = (definitions, query) => {
  const needle = normalizeQuery(query);
  const groupCounts = new Map();
  definitions.forEach(({groupId}) => {
    if (!groupCounts.has(groupId)) groupCounts.set(groupId, 0);
  });
  if (!needle) {
    return {
      active: false,
      needle,
      rowMatches: new Set(),
      groupCounts,
      totalMatches: 0,
      groupsHit: 0,
      openGroups: new Set(),
      dimmedGroups: new Set(),
      scope: 'none'
    };
  }

  const groupNameHit = new Set(
    definitions.filter(d => contains(d.group, needle)).map(d => d.groupId)
  );
  const rowMatches = new Set();
  const bands = new Set();
  definitions.forEach(definition => {
    const hit =
      groupNameHit.has(definition.groupId) ||
      contains(definition.label, needle) ||
      contains(definition.tooltip, needle);
    if (!hit) return;
    rowMatches.add(definition.key);
    bands.add(definition.band);
    groupCounts.set(
      definition.groupId,
      groupCounts.get(definition.groupId) + 1
    );
  });

  const openGroups = new Set();
  const dimmedGroups = new Set();
  groupCounts.forEach((count, id) =>
    (count > 0 ? openGroups : dimmedGroups).add(id)
  );

  return {
    active: true,
    needle,
    rowMatches,
    groupCounts,
    totalMatches: rowMatches.size,
    groupsHit: openGroups.size,
    openGroups,
    dimmedGroups,
    scope: scopeOf(bands)
  };
};

const foldWithOrigins = text => {
  let folded = '';
  const origins = [];
  let index = 0;
  for (const char of text) {
    const piece = fold(char);
    for (let k = 0; k < piece.length; k += 1) origins.push(index);
    folded += piece;
    index += char.length;
  }
  return {folded, origins};
};

const endOfCharAt = (text, index) => {
  let end = index + String.fromCodePoint(text.codePointAt(index)).length;
  while (end < text.length && fold(text[end]) === '') end += 1;
  return end;
};

export const splitAtMatch = (text, needle) => {
  if (!needle || typeof text !== 'string') return null;
  const {folded, origins} = foldWithOrigins(text);
  const index = folded.indexOf(needle);
  if (index < 0) return null;
  const start = origins[index];
  const end = endOfCharAt(text, origins[index + needle.length - 1]);
  return {
    before: text.slice(0, start),
    match: text.slice(start, end),
    after: text.slice(end)
  };
};
